import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { listCompetitions } from '@/lib/api';
import CompetitionCard from '@/components/comp/CompetitionCard';
import YellowRule from '@/components/brand/YellowRule';

const STATUSES = [
  { key: 'all', label: 'All' },
  { key: 'LIVE', label: 'Live now' },
  { key: 'SOLD_OUT', label: 'Sold out' },
  { key: 'WINNER_ANNOUNCED', label: 'Winner announced' },
];

const CompetitionsArchivePage = () => {
  const [items, setItems] = useState([]);
  const [search] = useSearchParams();
  const category = search.get('category');
  const [statusKey, setStatusKey] = useState('all');

  useEffect(() => {
    listCompetitions().then((d) => setItems(d.items || []));
  }, []);

  let filtered = items;
  if (statusKey !== 'all') filtered = filtered.filter((c) => c.status === statusKey);
  if (category) filtered = filtered.filter((c) => (c.category || '').toLowerCase() === category.toLowerCase());

  return (
    <div className="container-pd py-10 md:py-16" data-testid="archive-page">
      <div className="font-mono text-[10px] text-[color:var(--pd-accent-yellow)] uppercase tracking-[0.2em]">Competitions</div>
      <h1 className="font-display text-5xl md:text-6xl leading-[1.05] md:leading-none mt-3">All competitions</h1>
      {category && <div className="mt-2 font-mono text-sm text-muted-sage">Filtered by {category}</div>}
      <div className="mt-5 md:mt-6 flex flex-wrap gap-2">
        {STATUSES.map((s) => (
          <button
            key={s.key}
            onClick={() => setStatusKey(s.key)}
            className={`px-3 py-2 rounded-lg text-sm border ${statusKey === s.key ? 'border-[color:var(--pd-accent-yellow)] text-[color:var(--pd-accent-yellow)]' : 'border-pd text-muted-sage'}`}
            data-testid={`archive-filter-${s.key.toLowerCase()}`}
          >
            {s.label}
          </button>
        ))}
      </div>
      <YellowRule className="mt-6 mb-6 md:mb-8" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {filtered.map((c) => <CompetitionCard key={c.id} comp={c} />)}
      </div>
      {!filtered.length && <div className="mt-6 font-mono text-muted-sage">No competitions match that filter yet.</div>}
    </div>
  );
};

export default CompetitionsArchivePage;
